import React from "react";
import { Modal } from "react-bootstrap";
import Loadingcomponent from "../loader/loadingcomponent";
import { getImgSrc } from "../../services/common/CommonUtils";

const ToggleActivationModal = ({
  show,
  toggleModal,
  title,
  loading,
  message,
  cancelBtn,
  activationBtn,
  onConfirm,
}) => {
  return (
    <Modal
      show={show}
      backdrop="true"
      className="bottom_modal animated  slideInUp faster"
      onHide={toggleModal}
    >
      <Modal.Body className="text-center">
        <div className="modal_img mb-2">
          <img
            src={getImgSrc('/assets/images/Confirmation.gif')}
            alt='info_icon'
            width={60}
          />
        </div>
        {
          title && <h3 className="primary_16 mb-3">{title}</h3>
        }
        <p className="modal_p mb-4">{message}</p>
        <div className="flex_grp_align_center">
          <button
            type="button"
            className={`custom_btn custom_btn_primary_outline btn_block me-2 ${loading ? 'disabled_border' : ''}`}
            onClick={toggleModal}
            disabled={loading}
          >
            {cancelBtn}
          </button>

          <button
            type="button"
            className={`custom_btn custom_btn_primary btn_block`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <Loadingcomponent /> : activationBtn}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ToggleActivationModal;
